"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var formConfig = {
  name: "employeeChangePassword",
  fields: {
    existingPassword: {
      id: "employee-current-password",
      jsonPath: "existingPassword",
      required: true,
      type: "password",
      floatingLabelText: "Existing Password",
      errorMessage: "Invalid Existing Password",
      hintText: "Existing Password",
      pattern: "^([a-zA-Z0-9@#$%])+$",
      value: ""
    },
    newpassword: {
      id: "employee-new-password",
      jsonPath: "newPassword",
      required: true,
      type: "password",
      floatingLabelText: "New Password",
      errorMessage: "Invalid New Password",
      hintText: "New Password",
      pattern: "^([a-zA-Z0-9@#$%])+$",
      value: ""
    },
    confirmnewpassword: {
      id: "employee-confirm-new-password",
      jsonPath: "newPassword",
      required: true,
      type: "password",
      floatingLabelText: "Confirm New Password",
      errorMessage: "Invalid New Password",
      hintText: "Confirm New Password",
      pattern: "^([a-zA-Z0-9@#$%])+$",
      value: ""
    }
  },
  submit: {
    type: "submit",
    label: "Change Password",
    id: "employee-change-password-submit-action"
  },
  saveUrl: "/user/password/_update",
  redirectionRoute: "/inbox",
  action: "_update"
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/employeeChangePassword.js
// module id = 2082
// module chunks = 1137